function initCustomSwipers() {
  document.querySelectorAll('.custom-swiper').forEach(function (section) {
    if (section.dataset.swiperInit) return;
    section.dataset.swiperInit = 'true';

    var swiperEl = section.querySelector('.custom-swiper__swiper.swiper');
    if (!swiperEl) return;

    var pcSpace = parseInt(section.dataset.pcSpacebetween, 10);
    if (isNaN(pcSpace) || pcSpace < 0) pcSpace = 20;
    var mbSpace = parseInt(section.dataset.mbSpacebetween, 10);
    if (isNaN(mbSpace) || mbSpace < 0) mbSpace = 12;

    var baseSlidesPerView = {
      mobile: parseFloat(section.dataset.mbSlide) || 1,
      ipad: parseFloat(section.dataset.ipadSlide) || 1,
      pc: parseFloat(section.dataset.pcSlide) || 1,
    };

    var config = {
      slidesPerView: section.dataset.mbSlide || 1,
      spaceBetween: mbSpace,
      grabCursor: true,
      speed: 400,
      breakpoints: {
        768: {
          slidesPerView: section.dataset.ipadSlide || 1,
          spaceBetween: pcSpace,
        },
        1024: {
          slidesPerView: section.dataset.pcSlide || 1,
          spaceBetween: pcSpace,
        },
      },
    };

    var isStyle3 = section.classList.contains('custom-swiper-style3');
    var isStyle1 = section.classList.contains('custom-swiper-style1');
    if (isStyle1) {
      // Let the whole style1 swiper container receive the touch gesture on
      // mobile instead of limiting it to the slide wrapper/content area.
      config.touchEventsTarget = 'container';
      config.allowTouchMove = true;
      config.threshold = 5;
    }

    if (isStyle3) {
      config.slidesPerView = 1;
      config.spaceBetween = 0;
      config.breakpoints = {
        768: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      };
    }

    var enableFade = section.dataset.enableFade === 'true';
    if (enableFade) {
      config.effect = 'fade';
      config.fadeEffect = {
        crossFade: true,
      };
      // Swiper's fade effect is designed for one visible slide at a time.
      config.slidesPerView = 1;
      config.spaceBetween = 0;
      config.breakpoints = {
        768: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        1024: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
      };
    }

    var prevEl = section.querySelector('.swiper-button-prev');
    var nextEl = section.querySelector('.swiper-button-next');
    if (prevEl && nextEl) {
      config.navigation = {
        prevEl: prevEl,
        nextEl: nextEl,
      };
    }

    var paginationEl = section.querySelector('.swiper-pagination');
    if (paginationEl) {
      config.pagination = {
        el: paginationEl,
        clickable: true,
      };
    }

    var totalEl = section.querySelector('[data-swiper-total]');
    if (totalEl) {
      var totalCurrent = totalEl.querySelector('[data-swiper-total-current]');
      var totalCount = totalEl.querySelector('[data-swiper-total-count]');
      var updateTotal = function (swiper) {
        var perView = swiper.params.slidesPerView === 'auto' ? 1 : Math.max(1, Math.floor(swiper.params.slidesPerView || 1));
        var total = Math.max(1, swiper.slides.length - perView + 1);
        if (totalCurrent) totalCurrent.textContent = swiper.activeIndex + 1;
        if (totalCount) totalCount.textContent = total;
      };
      config.on = {
        init: updateTotal,
        slideChange: updateTotal,
      };
    }

    // Tab navigation synced with the single swiper.
    // Tab buttons are generated from tab_settings (text/select/image 1-6).
    var tabsEl = section.querySelector('[data-swiper-tabs]');
    if (tabsEl) {
      var tabButtons = tabsEl.querySelectorAll('[data-tab]');
      var tabImageEl = section.querySelector('[data-swiper-tab-image]');
      var tabLayoutEl = section.querySelector('[data-swiper-tab-layout]');
      var tabLeftEl = section.querySelector('[data-swiper-tab-left]');

      var findTabButton = function (tabId) {
        for (var i = 0; i < tabButtons.length; i++) {
          if (tabButtons[i].dataset.tab === tabId) return tabButtons[i];
        }
        return null;
      };

      var setActiveTab = function (tabId) {
        var btn = findTabButton(tabId);
        if (!btn) return;
        tabButtons.forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
        });
        var tabImage = btn.dataset.tabImage || '';
        var hasTabImage = Boolean(tabImage);
        if (tabImageEl) {
          if (hasTabImage) {
            tabImageEl.src = tabImage;
          } else {
            tabImageEl.removeAttribute('src');
            tabImageEl.removeAttribute('srcset');
          }
        }
        if (tabLayoutEl) {
          tabLayoutEl.classList.toggle('cus-swiper_style2-no-img', !hasTabImage);
        }
        if (tabLeftEl) {
          tabLeftEl.hidden = !hasTabImage;
        }
        if (typeof updateTabSlidesPerView === 'function') {
          updateTabSlidesPerView(hasTabImage);
        }
        var viewText = btn.dataset.collectionViewText || '';
        var viewUrl = btn.dataset.collectionViewUrl || '';
        var hasView = Boolean(viewText && viewUrl);
        section.querySelectorAll('[data-collection-view-wrap]').forEach(function (wrap) {
          wrap.hidden = !hasView;
        });
        section.querySelectorAll('[data-collection-view]').forEach(function (view) {
          view.classList.toggle('d-none', !viewText);
          view.href = viewUrl;
          var text = view.querySelector('[data-collection-view-text]');
          if (text) text.textContent = viewText;
        });
      };

      // Hide slides that don't belong to the active tab, show the rest
      var filterSlides = function (sw, tabId) {
        for (var i = 0; i < sw.slides.length; i++) {
          var slide = sw.slides[i];
          var match = slide.getAttribute('data-tab-type') === tabId;
          slide.classList.toggle('swiper-slide-hidden', !match);
        }
      };


      // Merge with existing on-handlers (e.g. total counter)
      var existingOn = config.on || {};
      config.on = Object.assign({}, existingOn, {
        init: function (sw) {
          if (existingOn.init) existingOn.init(sw);
          // Filter to first tab's slides on init
          var firstTabId = tabButtons[0] && tabButtons[0].dataset.tab;
          if (firstTabId) {
            filterSlides(sw, firstTabId);
            sw.update();
          }
        },
        slideChange: function (sw) {
          if (existingOn.slideChange) existingOn.slideChange(sw);
        },
      });
    }

    var swiper = new Swiper(swiperEl, config);

    // On desktop, when a tab has no left-side image, use one additional slide
    // slot so the right-side carousel keeps the same visual width as tabs with
    // an image. Mobile and tablet retain their original slide count.
    var updateTabSlidesPerView = function (hasImage) {
      if (!tabsEl || isStyle3 || enableFade) return;

      // Only the desktop layout expands to full width when the tab image is
      // missing. Mobile hides the left panel, so its original slide width
      // should remain unchanged.
      var increment = !hasImage && window.innerWidth >= 1024 ? 1 : 0;
      var targetSlidesPerView = baseSlidesPerView.mobile + increment;
      if (window.innerWidth >= 1024) {
        targetSlidesPerView = baseSlidesPerView.pc + increment;
      } else if (window.innerWidth >= 768) {
        targetSlidesPerView = baseSlidesPerView.ipad + increment;
      }

      swiper.params.slidesPerView = targetSlidesPerView;
      swiper.update();
    };

    if (tabsEl) {
      swiper.on('breakpoint', function () {
        var activeTab = tabsEl.querySelector('[data-tab].is-active') || tabsEl.querySelector('[data-tab]');
        updateTabSlidesPerView(Boolean(activeTab && activeTab.dataset.tabImage));
      });
    }

    if (isStyle3) {
      initCustomSwiperStyle3(section, swiper);
    }

    if (tabsEl) {
      // Tabs themselves form a free-mode swiper so they can scroll when
      // they overflow the viewport, with left/right arrow controls.
      var tabsPrev = section.querySelector('[data-tabs-prev]');
      var tabsNext = section.querySelector('[data-tabs-next]');
      var tabsWrap = tabsEl.closest('.custom-swiper__tabs-wrap');
      // Trailing space that keeps the last tab clear of the right arrow area
      // while the tabs scroll. It is only applied when they really overflow
      // (see updateTabsArrows), otherwise it fakes a scroll range and shifts
      // the tabs on click even though there is nothing to scroll.
      var tabsOffsetAfter = tabsPrev || tabsNext ? 10 : 0;
      var tabNavSwiper = new Swiper(tabsEl, {
        slidesPerView: 'auto',
        spaceBetween: 0,
        slidesOffsetAfter: tabsOffsetAfter,
        freeMode: {
          enabled: true,
          momentum: true,
        },
        watchOverflow: true,
        resistanceRatio: 0,
        observer: true,
        observeParents: true,
      });

      var updateTabsArrows = function () {
        if (!tabsWrap) return;
        var tabsWidth = tabNavSwiper.wrapperEl ? tabNavSwiper.wrapperEl.scrollWidth : tabsEl.scrollWidth;
        var viewportWidth = Math.min(tabsEl.clientWidth, window.innerWidth);
        var hasOverflow = tabsWidth > viewportWidth + 1;

        // When the wrapper is narrower than the tab bar there is nothing to
        // scroll, so drop slidesOffsetAfter: keeping it would let Swiper
        // translate the row by that offset on click or drag.
        var offsetAfter = hasOverflow ? tabsOffsetAfter : 0;
        if (tabNavSwiper.params.slidesOffsetAfter !== offsetAfter) {
          tabNavSwiper.params.slidesOffsetAfter = offsetAfter;
          tabNavSwiper.update();
        }

        tabsWrap.classList.toggle('is-overflowing', hasOverflow);
        tabsWrap.classList.toggle('is-locked', !hasOverflow);
        tabsWrap.classList.toggle('is-at-start', !hasOverflow || tabNavSwiper.isBeginning);
        tabsWrap.classList.toggle('is-at-end', !hasOverflow || tabNavSwiper.isEnd);
        tabsPrev && tabsPrev.classList.toggle('is-disabled', !hasOverflow || tabNavSwiper.isBeginning);
        tabsNext && tabsNext.classList.toggle('is-disabled', !hasOverflow || tabNavSwiper.isEnd);
        tabsPrev && (tabsPrev.disabled = !hasOverflow || tabNavSwiper.isBeginning);
        tabsNext && (tabsNext.disabled = !hasOverflow || tabNavSwiper.isEnd);
        tabsPrev && tabsPrev.setAttribute('aria-hidden', !hasOverflow || tabNavSwiper.isBeginning ? 'true' : 'false');
        tabsNext && tabsNext.setAttribute('aria-hidden', !hasOverflow || tabNavSwiper.isEnd ? 'true' : 'false');
      };
      tabNavSwiper.on(
        'init slideChange resize observerUpdate reachBeginning reachEnd fromEdge touchEnd transitionEnd',
        updateTabsArrows
      );
      updateTabsArrows();

      var initialTab = tabButtons[0];
      updateTabSlidesPerView(Boolean(initialTab && initialTab.dataset.tabImage));

      window.addEventListener('resize', function () {
        tabNavSwiper.update();
        updateTabsArrows();
        var activeTab = tabsEl.querySelector('[data-tab].is-active') || tabsEl.querySelector('[data-tab]');
        updateTabSlidesPerView(Boolean(activeTab && activeTab.dataset.tabImage));
      });

      tabsPrev && tabsPrev.addEventListener('click', function () { tabNavSwiper.slidePrev(); });
      tabsNext && tabsNext.addEventListener('click', function () { tabNavSwiper.slideNext(); });

      tabButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var tabId = btn.dataset.tab;
          // Filter slides to only show this tab's content
          filterSlides(swiper, tabId);
          swiper.update();
          swiper.slideTo(0, 0);
          setActiveTab(tabId);
          // Bring the clicked tab into view, but only when the tab bar really
          // scrolls, otherwise Swiper would nudge the row on every click.
          if (tabsWrap && tabsWrap.classList.contains('is-overflowing')) {
            var slideEl = btn.closest('.swiper-slide');
            if (slideEl) {
              var idx = tabNavSwiper.slides.indexOf(slideEl);
              if (idx > -1) tabNavSwiper.slideTo(idx);
            }
          }
        });
      });
    }

    initVideoModal(section);
  });
}

function initCustomSwiperStyle3(section, swiper) {
  var list = section.querySelector('[data-style3-list]');
  if (!list) return;

  var items = Array.prototype.slice.call(list.querySelectorAll('[data-style3-index]'));
  if (!items.length) return;

  var ensureSlideImages = function (slide) {
    if (!slide) return;
    slide.querySelectorAll('img[data-src]').forEach(function (img) {
      if (!img.getAttribute('src') && img.dataset.src) {
        img.setAttribute('src', img.dataset.src);
      }
    });
  };

  var updateActiveItem = function (sw) {
    var activeIndex = typeof sw.realIndex === 'number' ? sw.realIndex : sw.activeIndex;
    items.forEach(function (item, index) {
      var isActive = index === activeIndex;
      item.classList.toggle('is-active', isActive);
      item.setAttribute('aria-selected', isActive ? 'true' : 'false');
      item.tabIndex = isActive ? 0 : -1;
    });
    ensureSlideImages(sw.slides[activeIndex]);
  };

  items.forEach(function (item) {
    item.addEventListener('click', function () {
      var index = parseInt(item.dataset.style3Index, 10);
      if (!isNaN(index)) swiper.slideTo(index);
    });
  });

  // The style3 list sits outside the main Swiper, so add the same mobile
  // swipe behavior to it. A horizontal swipe changes the main slide while
  // preserving the existing click-to-select behavior.
  var swipeStartX = 0;
  var swipeStartY = 0;
  var swipePointerId = null;
  var suppressClick = false;

  list.addEventListener('pointerdown', function (event) {
    if (window.matchMedia && !window.matchMedia('(max-width: 767px)').matches) return;
    if (event.pointerType === 'mouse') return;

    swipeStartX = event.clientX;
    swipeStartY = event.clientY;
    swipePointerId = event.pointerId;
    if (list.setPointerCapture) list.setPointerCapture(event.pointerId);
  });

  list.addEventListener('pointerup', function (event) {
    if (swipePointerId !== event.pointerId) return;

    var deltaX = event.clientX - swipeStartX;
    var deltaY = event.clientY - swipeStartY;
    swipePointerId = null;

    if (Math.abs(deltaX) < 30 || Math.abs(deltaX) <= Math.abs(deltaY)) return;

    suppressClick = true;
    if (deltaX < 0) {
      swiper.slideNext();
    } else {
      swiper.slidePrev();
    }
    window.setTimeout(function () {
      suppressClick = false;
    }, 400);
  });

  list.addEventListener('pointercancel', function () {
    swipePointerId = null;
  });

  list.addEventListener('click', function (event) {
    if (!suppressClick) return;
    event.preventDefault();
    event.stopPropagation();
    suppressClick = false;
  }, true);

  swiper.on('init slideChange transitionEnd', updateActiveItem);
  updateActiveItem(swiper);
}

function initVideoModal(section) {
  var modal = section.querySelector('[data-video-modal]');
  if (!modal) return;

  var container = modal.querySelector('[data-video-container]');

  function closeModal() {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    setTimeout(function () {
      container.innerHTML = '';
    }, 300);
  }

  section.querySelectorAll('[data-video-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var template = document.getElementById(btn.dataset.videoTrigger);
      if (!template) return;
      container.innerHTML = '';
      container.appendChild(template.content.cloneNode(true));
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    });
  });

  modal.querySelectorAll('[data-video-close]').forEach(function (el) {
    el.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });
}

if (window.Swiper) {
  initCustomSwipers();
} else {
  var checkSwiper = setInterval(function () {
    if (window.Swiper) {
      clearInterval(checkSwiper);
      initCustomSwipers();
    }
  }, 100);
}
